export {
  SURVEY_STATUS_LABEL,
  SURVEY_STATUS_VARIANT,
  SURVEY_RESPONSE_TYPE_LABEL,
  EXPIRATION_LABEL,
  EXPIRATION_OPTIONS,
  RESPONSE_TYPE_LABEL,
  QUESTION_TYPES,
  isSurveyEditable,
  isSurveyStructureEditable,
  normalizeIdentifiedSurveyFields,
} from '../constants/survey';

/** Classificação NPS pela nota (0–10). */
export function npsClass(score: number): 'promoter' | 'passive' | 'detractor' {
  if (score >= 9) return 'promoter';
  if (score >= 7) return 'passive';
  return 'detractor';
}

/** Faixa qualitativa do NPS (-100..100). */
export function npsZone(score: number): { label: string; className: string } {
  if (score >= 75) return { label: 'Excelente', className: 'text-success' };
  if (score >= 50) return { label: 'Muito bom', className: 'text-success' };
  if (score >= 0) return { label: 'Razoável', className: 'text-warning' };
  return { label: 'Crítico', className: 'text-destructive' };
}

function capitalizeFirst(value: string): string {
  if (!value) return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export { capitalizeFirst };
